<nav [ngClass]="'type-' + ListingPropertyType[platform]" role="menu" *ngIf="showLeftNav" [@leftNavTrigger]>
  <div class="red-bar bar has-pos-abs full-width" *ngIf="platform !== ListingPropertyType.LUXURY"></div>
  <ul class="nav category is-flex has-flex-align-start has-flex-content-start">
    <li role="presentation" (click)="onCloseLeftNavClick.emit()">
      <i class="material-icons">close</i>
    </li>
    <li role="presentation" class="active-logo" (click)="onCloseLeftNavClick.emit()">
      <img [style.width.px]="icons.top.img.width" [lazyLoad]="icons.top.img.src" [defaultImage]="icons.top.img.src"  [alt]="icons.top.img.alt|translate"
      />
    </li>
  </ul>
  <app-site-links [platform]="platform" (toggleLuxury)="changeListingType(ListingPropertyType.LUXURY)" (onListingsClick)="onListingsClick.emit()"></app-site-links>
  <p class="text-center">
    {{'side-nav.left-nav.also-check-out'|translate}}
  </p>
  <ul class="nav category is-flex has-flex-align-center has-flex-content-start">
    <a (click)="changeListingType(icons.left.img.type, $event)" [href]="icons.left.link">
      <li role="presentation" class="logo" >
        <img [style.width.px]="icons.left.img.width" [lazyLoad]="icons.left.img.src" [defaultImage]="icons.left.img.src" [alt]="icons.left.img.alt|translate" />
      </li>
    </a>
    <a (click)="changeListingType(icons.right.img.type, $event)" [href]="icons.right.link">
      <li role="presentation" class="logo" >
        <img [style.width.px]="icons.right.img.width" [lazyLoad]="icons.right.img.src" [defaultImage]="icons.right.img.src" [alt]="icons.right.img.alt|translate" />
      </li>
    </a>
  </ul>
</nav>
